
import { createSlice } from '@reduxjs/toolkit';
import { getAuthProps, setAuthProps, signOut } from '../../utils/authentication/authLibrary';
import { saveData } from '../../utils/localStorage/LocalStorageHandler';
import {
    ENABLED_MODULE_CODES_STORAGE_KEY,
    productModuleCodes,
} from '../../enums/ProductModuleCodes.ENUM';

const authData = getAuthProps();

const normalizeEnabledModuleCodes = (codes) => {
    if (!Array.isArray(codes) || codes.length === 0) {
        return [productModuleCodes.CORE_ATS];
    }
    const normalized = codes.map((c) => String(c)).filter(Boolean);
    if (!normalized.includes(productModuleCodes.CORE_ATS)) {
        normalized.unshift(productModuleCodes.CORE_ATS);
    }
    return normalized;
};

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: (authData != null),
        user: (authData?.user),
        token: (authData?.token),
        roles: (authData?.roles),
        authData,
        isLoggedIn: (authData?.isAuthenticated),
        userPermissions: (authData?.securityPermissions),
        enabledModuleCodes: normalizeEnabledModuleCodes(authData?.enabledModuleCodes),
    },

    reducers: {
        authentication: (state, action) => {

            const { message, securityPermissions, enabledModuleCodes, ...newAuthProps } = action.payload;

            const { isAuthenticated, roles } = action.payload;
            const userDetails = { ...newAuthProps.user }
            const moduleCodes = normalizeEnabledModuleCodes(enabledModuleCodes);

            setAuthProps({ ...newAuthProps, enabledModuleCodes: moduleCodes });

            state.userPermissions = securityPermissions;
            state.enabledModuleCodes = moduleCodes;
            state.isAuthenticated = isAuthenticated;
            state.roles = roles;
            state.user = userDetails;

            state.isLoggedIn = true;
            saveData("SecurityPermission", securityPermissions);
            saveData(ENABLED_MODULE_CODES_STORAGE_KEY, moduleCodes);
        },
        logout: (state) => {
            state.isLoggedIn = false;
            state.enabledModuleCodes = [productModuleCodes.CORE_ATS];
            signOut();
        },
    },
});

export const { authentication, logout } = authSlice.actions;

export default authSlice.reducer;
